import React from "react";
import { Avatar, Button, Tooltip } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import { Localize } from "components/service";
import { timeFormat } from "utils/helper-functions";
import { getInitials, getScanPoints, PlaceholderTableLink } from "./event-attendance-helper";

const getShiftScanDetails = (shift) => ({
    worker: shift.worker,
    subcontractor: shift.subcontractor,
    check_in_at: shift.check_in_at,
    check_out_at: shift.check_out_at,
    scan_logs: shift.scan_logs || [],
    points: getScanPoints(shift.scan_logs),
    isShiftDetails: true,
});

const EventAttendanceShiftsTableHelper = (openLocation) => {
    const columns = [
        {
            title: <Localize>TABLES.Column_Title_Worker</Localize>,
            dataIndex: "worker",
            width: "20%",
        },
        {
            title: <Localize>TABLES.Column_Title_Subcontractor</Localize>,
            dataIndex: "subcontractor",
            width: "20%",
        },
        {
            title: <Localize>TABLES.Column_Title_CheckInTime</Localize>,
            dataIndex: "checkInTime",
            width: "20%",
        },
        {
            title: <Localize>TABLES.Column_Title_CheckOutTime</Localize>,
            dataIndex: "checkOutTime",
            width: "20%",
        },
        {
            title: (
                <Tooltip title={ <Localize>TABLES.Tooltip_ShiftScanLocations</Localize> }>
                    <span><Localize>TABLES.Column_Title_AttendanceScanLogs</Localize></span>
                </Tooltip>
            ),
            dataIndex: "scanLogs",
            align: "center",
            width: "20%",
        },
    ];

    const data = (shifts) => {
        if (!shifts)
        {
            return [];
        }

        return shifts.map((shift) => {
            const workerName = `${ shift.worker.name } ${ shift.worker.surname }`;
            const isCompleted = !!shift.check_out_at;
            const hasLogs = (shift.scan_logs || []).length > 0;

            return {
                key: shift.id,
                worker: (
                    <span className="event-check-logs-worker">
                        <Avatar size={ 32 }>{ getInitials(shift.worker) }</Avatar>
                        <PlaceholderTableLink>{ workerName }</PlaceholderTableLink>
                    </span>
                ),
                subcontractor: <PlaceholderTableLink>{ shift.subcontractor.title }</PlaceholderTableLink>,
                checkInTime: timeFormat(shift.check_in_at, "DD.MM.YYYY HH:mm:ss"),
                checkOutTime: isCompleted ? timeFormat(shift.check_out_at, "DD.MM.YYYY HH:mm:ss") : "-",
                scanLogs: (
                    <Tooltip title={
                        hasLogs ?
                            <Localize>TABLES.Tooltip_ShiftScanLocations</Localize> :
                            <Localize>CHECK_LOGS.Tooltip_NoScanLogs</Localize>
                    }>
                        <span>
                            <Button
                                type="text"
                                className="event-attendance-location-button event-attendance-location-button--logs"
                                disabled={ !hasLogs }
                                icon={ <EnvironmentOutlined /> }
                                onClick={ () => openLocation(getShiftScanDetails(shift)) }>
                                <Localize>CHECK_LOGS.Button_ScanLogs</Localize>
                            </Button>
                        </span>
                    </Tooltip>
                ),
            };
        });
    };

    return {
        columns,
        data,
    };
};

export default EventAttendanceShiftsTableHelper;
